import { axiosInstance } from 'src/util/axios/instance.axios'
import { AiAssistantAction, AiAssistantInitRequest, AiAssistantInitResponse } from '../model/ai-assistant.model'

type AiAssistantInitResponseLegacy = AiAssistantInitResponse & {
  quickActions?: AiAssistantAction[]
}

export async function initAssistant(request: AiAssistantInitRequest): Promise<AiAssistantInitResponse> {
  const { data } = await axiosInstance.request<AiAssistantInitResponseLegacy>({
    url: '/ai-assistant/init',
    method: 'post',
    data: request,
  })

  return {
    ...data,
    actions: data.actions ?? data.quickActions ?? [],
  }
}